// extracted by mini-css-extract-plugin
module.exports = {"comments":"post-comment-module--comments--YfBfl"};